import { Box, BoxProps } from "@material-ui/core";
import React from "react";

type Props = {
  checked?: boolean;
  onClick?: () => void;
} & BoxProps;

export default function CheckmarkButton({
  checked,
  onClick,
  ...boxProps
}: Props) {
  return (
    <Box {...boxProps} onClick={onClick}>
      {checked && (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.3 13C24.3 19.2408 19.2408 24.3 13 24.3C6.75918 24.3 1.7 19.2408 1.7 13C1.7 6.75918 6.75918 1.7 13 1.7C19.2408 1.7 24.3 6.75918 24.3 13ZM26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13ZM19.601 9.60104C19.933 9.2691 19.933 8.7309 19.601 8.39896C19.2691 8.06701 18.7309 8.06701 18.399 8.39896L11 15.7979L7.60104 12.399C7.26909 12.067 6.73091 12.067 6.39896 12.399C6.06701 12.7309 6.06701 13.2691 6.39896 13.601L10.399 17.601C10.7309 17.933 11.2691 17.933 11.601 17.601L19.601 9.60104Z"
            fill="#FF8C33"
          />
        </svg>
      )}
      {!checked && (
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ cursor: onClick ? "pointer" : "default" }}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 24.3C19.2408 24.3 24.3 19.2408 24.3 13C24.3 6.75918 19.2408 1.7 13 1.7C6.75918 1.7 1.7 6.75918 1.7 13C1.7 19.2408 6.75918 24.3 13 24.3ZM13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z"
            fill="#C5C1BA"
          />
        </svg>
      )}
    </Box>
  );
}
